var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSafety = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_975_49191)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_975_49191)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    width: 48,
    height: 48,
    rx: 24,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_975_49191)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 28.3138,
    cy: 24.0013,
    rx: 12.9153,
    ry: 13.4583,
    stroke: "currentColor",
    strokeWidth: 2.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 28.3141,
    cy: 24,
    rx: 6.11779,
    ry: 6.375,
    stroke: "currentColor",
    strokeWidth: 2.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4385 17.625L22.1968 22.5833M34.4323 35.3333L29.6741 30.375",
    stroke: "currentColor",
    strokeWidth: 2.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5166 12.668L26.2749 17.6263M39.1902 31.0846L34.4319 26.1263",
    stroke: "currentColor",
    strokeWidth: 2.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4316 12.668L29.6734 17.6263M17.0979 30.7305L22.1961 25.418",
    stroke: "currentColor",
    strokeWidth: 2.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.8506 17.2695L34.4322 21.8737M21.8567 34.9779L26.2751 30.3737",
    stroke: "currentColor",
    strokeWidth: 2.4
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_975_49191",
    x: 0,
    y: 0,
    width: 56,
    height: 56,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_975_49191"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_975_49191",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_975_49191",
    x: -12,
    y: -9,
    width: 80.6279,
    height: 82,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_975_49191"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_975_49191",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_975_49191"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    width: 48,
    height: 48,
    rx: 24,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSafety);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/safety.a439b81c5c8c6a7eafaddb19cda7cf15.svg";